var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import MarpReady from '@marp-team/marp-core/lib/browser.cjs';
import nanoid from 'nanoid/generate';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import MarpSlide from './MarpSlide';
import { containerSymbol } from './utils/symbol';
const identifierChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const identifier = () => nanoid(identifierChars, 8);
let MarpBase = class MarpBase extends Vue {
    data() {
        return {
            $_marp_container: Object.freeze({ class: `marp-${identifier()}` }),
        };
    }
    get $_marp_options() {
        return Object.assign({}, this.options, { container: false, markdown: Object.assign({}, (this.options.markdown || {}), { xhtmlOut: true }), slideContainer: {
                tag: 'div',
                class: this.$data.$_marp_container.class,
            } });
    }
    get $_marp_style() {
        return `
div.${this.$data.$_marp_container.class}{all:initial;}
div.${this.$data.$_marp_container.class} > svg[data-marpit-svg]{display:block;will-change:transform;}
    `.trim();
    }
    mounted() {
        MarpReady();
    }
};
__decorate([
    Prop({ type: String })
], MarpBase.prototype, "markdown", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], MarpBase.prototype, "options", void 0);
MarpBase = __decorate([
    Component({
        components: { MarpSlide },
        provide() {
            return { [containerSymbol]: this.$data.$_marp_container.class };
        },
    })
], MarpBase);
export default MarpBase;
